import React, { Suspense, lazy, useCallback, useState, useEffect } from 'react'
import { Box, Container, Link, Stack, Typography, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField, Button, Skeleton, IconButton } from "@mui/material"
import classNames from 'classnames'

// Components
import CopyRight from "./CopyRight"
// const CopyRight = lazy(() => import('./CopyRight'))

// Assets
import { MapIcon, PhoneCall, TwitterIcon, FeedIcon, ChevronRight, InstagramIcon1 } from "../../assets/icons/index"

// Utils
import { useAppSelector } from '@/hooks'
import { apicall, trimAllSpaceFromString } from '@/utils/helper'
import { Link as NavigationLink, navigate } from "gatsby"

export interface FooterLink {
  linkTitle: string;
  linkUrl: string;
}

function index({ configDetails = null, footerDetails = null }: { configDetails: any, footerDetails: any }) {
  let { configDetails: configDetailsState, footerSections: footerDetailsState } = useAppSelector((state) => state.homePage)
  configDetailsState = configDetailsState ?? configDetails
  footerDetailsState = footerDetails ?? footerDetailsState
  return (
    <Box id="MainFooterSection" component="footer">
      <Container className="Container">
        <Stack className="FooterWrapper">
          <Stack className="LogoPart">
            <Link style={{ cursor: 'pointer' }} href={'/'}>
              <img src={configDetailsState?.BrandLogoURL_Footer?.value} alt="Footer logo" loading="lazy"
              // onClick={()=>{
              //   navigate('/')
              // }}
              />
            </Link>
            <Stack className="AboutWrapper">
              <Stack className="LocationWrapper About">
                <MapIcon />
                <Typography className="Location" variant="body1" component="address">{configDetailsState?.Store_Address?.value}</Typography>
              </Stack>
              <Stack className="MailWrapper About">
                <PhoneCall fontSize='large' />
                <Link href={"tel:" + configDetailsState?.["StorePhoneNumber_AU"]?.value} variant="body1" className="Mail">{configDetailsState?.["StorePhoneNumber_AU"]?.value}</Link>
              </Stack>
              {/* <Stack className="MailWrapper About">
                <MailIcon />
                <Link href={"mailto:" + configDetailsState?.storecontactemail?.value} variant="body2" className="Mail">{configDetailsState?.storecontactemail?.value}</Link>
              </Stack> */}
            </Stack>
          </Stack>
          <Stack className="MenuesPart" component="nav">
            {footerDetailsState?.map((menu) => (
              <Box key={menu.mainTitle} className={classNames("MenuWrapper", trimAllSpaceFromString(menu.mainTitle))}>
                <Typography className="MenuTitle" variant="subtitle2" component="p">{menu.mainTitle.toLocaleLowerCase()}</Typography>
                <List>
                  {menu.links.map((item: any) => (
                    <ListItem key={item.linkTitle}>
                      <ListItemButton onClick={() => {
                        navigate(item.linkUrl)
                      }}>
                        <ListItemIcon>
                          <ChevronRight />
                        </ListItemIcon>
                        <ListItemText primary={item.linkTitle} primaryTypographyProps={{ variant: "body1" }} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Stack>
        </Stack>
      </Container>
      <CopyRight configDetails={configDetailsState} />
    </Box>
  )
}

export default index